{{#if options.title}}
<div class="row p-b-10">
	<div class="col-sm-12">
		{{#if options.isInModal}}
		<h5 id="ct-{{options.headingID}}-heading" class="js-abstract-table-title">{{options.title}}</h5>
		{{else}}
		<h4 id="ct-{{options.headingID}}-heading" class="page-title js-abstract-table-title">{{options.title}}</h4>
		{{/if}}
	</div>
</div>
{{/if}}
{{#if options.headerHTML}}
<div class="card-box clearfix">
	<div class="row">
	    <div class="col-xs-11">
			{{{options.headerHTML}}}
	    </div>
	</div>
</div>
{{/if}}
{{#each options.warnings}}
<div class="row">
	<div class="col-xs-12">
		<div class="alert alert-info">
			<strong>{{title}}</strong> {{info}}</div>
		</div>
	</div>
</div>
{{/each}}
<div class="row">
	<div class="col-sm-12">
		{{#unless options.isInModal}}
		<div class="card-box clearfix">
		{{/unless}}
			<table class="tablesaw table m-b-0" data-tablesaw-mode="swipe" data-tablesaw-sortable>
				<thead>
					<tr>
						{{#if options.hasSelectionButtons}}
						<th class="selector-column sticky-table-heading" scope="col" data-tablesaw-priority="persist">
							{{#COMPARE nrModels '>' 0}}
							<input
								class="js-table-row-select js-select-all"
								data-row-id="select-all"
								type="checkbox"
								{{#COMPARE nrModels '==' nrSelected}}checked{{/COMPARE}}
							>
							</input>
							{{/COMPARE}}
						</th>
						{{/if}}

						{{#each options.columns}}
							<th id="h-{{this.name}}" scope="col"
								class="sticky-table-heading {{#if isSortDefault}} tablesaw-sortable-{{#if isSortDescending}}descending{{else}}ascending{{/if}}"
									data-tablesaw-sortable-default-col
								{{else}}"{{/if}}
								{{#unless this.notSortable}}
									data-tablesaw-sortable-col
								{{/unless}}
								{{#if sortIdx}}
									data-sort-idx="{{sortIdx}}"
								{{/if}}
								{{#if this.alwaysVisible}}
									data-tablesaw-priority="persist"
								{{/if}}
								{{#if this.isNumeric}}
									data-sortable-numeric
								{{/if}}
								>
								{{#if this.alwaysVisible}}
								{{TR this.name}}
								{{else}}
									{{#if ../isCompactMode}}
										{{#if this.abbreviation}}
										{{TR this.abbreviation}}
										{{else}}
										{{TR this.name}}
										{{/if}}
									{{else}}
										{{TR this.name}}
									{{/if}}
								{{/if}}
							</th>
						{{/each}}
					</tr>
				</thead>
				<tbody>
				</tbody>
				{{#if options.footRows}}
				<tfoot>
					{{#each options.footRows}}
					<tr>
						{{#if ../this.options.hasSelectionButtons}}
						<th>&nbsp;</th>
						{{/if}}
						{{#each ../this.options.columns}}
						<th>{{{OBJVALUE ../this this.id }}}</th>
						{{/each}}
					</tr>
					{{/each}}
				</tfoot>
				{{/if}}
			</table>

			<div class="row m-t-10">
				<div class="col-xs-12">
				{{#if options.hasSelectionButtons}}
					<div class="btn-group js-selection-buttons">

						{{#COMPARE options.selectionButtons.length '>' 2}}
						<div class="btn-group m-t-10 dropup">
							<button id="js-selection-action-menu" class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown">
								<i class="fa fa-wrench"></i>&nbsp;<span class="caret"></span>
							</button>
							<ul class="dropdown-menu dropdown-menu-left">
								{{#each options.selectionButtons}}
								{{#unless ForceButton}}
								{{#unless Hidden}}
								<li>
									<a href="#" class="js-{{this.ButtonID}} js-action js-tab-btn-{{this.ButtonID}} btn disabled dropdown-button" id="js-{{this.ButtonID}}">
										{{#if this.ButtonIcon}}<i class="{{this.ButtonIcon}} m-r-10" ></i>{{/if}}{{this.ButtonText}}
									</a>
								</li>
								{{/unless}}
								{{/unless}}
								{{/each}}
							</ul>
						</div>
						{{#each options.selectionButtons}}
							{{#if ForceButton}}
							{{#unless Hidden}}
							<div id="js-{{this.ButtonID}}" class="js-{{this.ButtonID}} ct-desktop h-large btn btn-default m-t-10 disabled js-tab-btn-{{this.ButtonID}}">
							{{#if this.ButtonIcon}}<i class="{{this.ButtonIcon}} m-r-5"></i> {{/if}}{{this.ButtonText}}</div>
							{{/unless}}
							{{/if}}
						{{/each}}
						{{else}}
							{{#each options.selectionButtons}}
								{{#unless Hidden}}
									<div id="js-{{this.ButtonID}}" class="js-{{this.ButtonID}} ct-desktop h-large btn btn-default m-t-10 disabled js-tab-btn-{{this.ButtonID}}">
									{{#if this.ButtonIcon}}<i class="{{this.ButtonIcon}} m-r-5"></i> {{/if}}{{this.ButtonText}}</div>
								{{/unless}}
							{{/each}}
						{{/COMPARE}}
					</div>
					{{#if options.CSVLink}}
					<a href="{{options.CSVLink}}" class="h-large btn btn-default m-t-10 js-csv-download ct-desktop"><i class="fa fa-table m-r-5"></i> {{TR 'CSV'}}</a>
					{{/if}}
				{{/if}}
					<div class="pull-right-m">
						{{#each options.customButtons}}
							<div id="js-{{this.ButtonID}}" class="js-{{this.ButtonID}} ct-desktop h-large btn btn-default m-t-10 js-tab-btn-{{this.ButtonID}}">{{#if this.ButtonIcon}}<i class="{{this.ButtonIcon}} {{#if this.ButtonText}}m-r-5{{/if}}"></i>{{/if}}
							{{this.ButtonText}}</div>
						{{/each}}
						{{#if options.hasRefreshButton}}
							<div id="js-refresh" class="h-large btn btn-default m-t-10 js-tab-btn-refresh ct-desktop">
								<i class="fa fa-refresh"></i>
							</div>
						{{/if}}
					</div>
				</div>
			</div>
		{{#unless options.isInModal}}
		</div>
		{{/unless}}
	</div>
</div>
{{#if options.footNote}}
<div class="row">
	<div class="col-sm-12">
		<div class="pull-right">
			{{{options.footNote}}}
		</div>
	</div>
</div>
{{/if}}
